import { create } from 'zustand';

type AnnouncementSlotState = {
  waitingCount: number;
  addWaiting: () => void;
  removeWaiting: () => void;
};

/**
 * Lets the Fellows promo know an announcement is queued behind it, so its
 * dismiss control can say what dismissing reveals instead of looking like a
 * delete.
 *
 * The promo mounts in the secure layout and announcements mount per screen, so
 * the promo cannot see them, and asking the announcement hook is circular: its
 * enabled flag already subtracts the promo. Screens announce themselves here
 * instead. Only screens that render an announcement call that hook, so nothing
 * has to keep a list of which routes those are — a list that would drift the
 * first time a screen gained or lost its banner.
 *
 * A count rather than a flag because focus and blur can overlap during a
 * navigation: increments and decrements commute, so a departing screen cannot
 * clear the arriving screen's registration.
 */
export const useAnnouncementSlotStore = create<AnnouncementSlotState>((set) => ({
  waitingCount: 0,
  addWaiting: () => set((state) => ({ waitingCount: state.waitingCount + 1 })),
  removeWaiting: () => set((state) => ({ waitingCount: Math.max(0, state.waitingCount - 1) })),
}));
